import React from 'react';
import { Links as LinkContainer, Link } from './styled';
import useResponsive from 'utils/hooks/useResponsive';
import { useTranslation } from 'react-i18next';

const Links = () => {
  const { t } = useTranslation();
  const { sm } = useResponsive();
  const links = [
    {name: t("whatIsFlixx"), href: '/flixx'},
    {name: t("creators"), href: '/be-a-creator'},
    {name: t("faqs"), href: '/faqs'},
    {name: t("termsAndConditions"), href: '/terminos-y-condiciones.html'},
    {name: t("policyPrivacy"), href: '/privacypolicy.html'},
  ];

  return (
    <LinkContainer column={sm}>
      {links.map(({name, href}, index) => (
        <Link
          key={index}
          href={href}
          as="a"
          color="white"
          column={sm}
          hasDot={index !== links.length - 1}
        >
          {name}
        </Link>
      ))}
    </LinkContainer>
  )
}

export default Links
